import '@vendors/easy-toc.min.js';

class CwTableOfContents {

    createTOC() {

        // media query event handler
        if (matchMedia) {
            const mobile = window.matchMedia("(max-width: 991px)");
            mobile.addListener(easyTOC);
            easyTOC(mobile);
        }

        // media query change
        function easyTOC(mobile) {
            if (mobile.matches) {
                const cwTOCMobile = new easy_toc(document.querySelector('#toc-table-mobile'), {
                    include: ['h2', 'h3', 'h4', 'h5'],
                    prefix: '',
                });
                cwTOCMobile.init();
            } else {
                const cwTOC = new easy_toc(document.querySelector('#toc-table'), {
                    include: ['h2', 'h3', 'h4', 'h5'],
                    prefix: '',
                });
                cwTOC.init();
            }

        }

        // remove appended hash in the url for every clicked link in TOC
        window.addEventListener("hashchange", function() {
            history.pushState("", document.title, window.location.pathname);
        });

        // remove punctuation marks in link tag hrefs and heading ids
        const regex = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g;

        let headings = [].slice.call(document.body.querySelectorAll('.anchor'));
        headings.forEach(function(heading) {
            let cleanHeading = heading.textContent.replace(regex, "");

            cleanHeading = cleanHeading.replace(/ /g, "_");
            heading.setAttribute("id", cleanHeading);
        });

        let links = document.getElementById("toc-table").querySelectorAll('a');
        links.forEach(function(link) {
            let cleanLink = link.textContent.replace(regex, "");
            cleanLink = cleanLink.replace(/ /g, "_");
            link.setAttribute("href", `#${cleanLink}`);
        });
    }

};

export default new CwTableOfContents();